import * as React from 'react';
import { useEffect } from 'react';
import TradePage from '../../../common/components/TradePage/TradePage';
import config from '../../../store/mmd/config';
import { ILoanConfirmationUIProps } from './LoanConfirmationInterfaces';
import GTPFlowPageSubtitle from '../GTPFlowPageSubtitle/GTPFlowPageSubtitle';

export const LoanConfirmationUI: React.FC<ILoanConfirmationUIProps> = (props) => {
    const {
        pageTitle,
        pageSubTitle,
        loanBalance,
        lenderName,
        vehicleName,
        trim,
        vin,
        stepperRoutes,
        selectedLoanBalanceOption,
        goToRoute,
        next,
        dispatchAnalytics,
        onEstimateBalanceClick,
        goBack,
        removeTradeIn,
        cdlPageView,
        cdlTradeInProgressStepperClicked,
        tradeIndex,
        urlPath
    } = props;

    useEffect(() => {
        cdlPageView();
    }, []);

    return (
        <TradePage
            headerOnTop
            showCustomTitle
            pageClass="loan-confirmation-page"
            pageTitle={pageTitle}
            pageSubTitle={<GTPFlowPageSubtitle pageSubtitle={pageSubTitle} suffix={vehicleName} tradeIndex={tradeIndex} />}
            goToRoute={goToRoute}
            dispatchAnalytics={dispatchAnalytics}
            footerProps={{
                showBackButton: true,
                onBackButtonClick: () => goBack(selectedLoanBalanceOption),
                disableActionButton: false,
                fullWidthLayout: true,
                showSkipButton: true,
                skipButtonText: 'Cancel Trade-in',
                onSkipButtonClick: removeTradeIn
            }}
            stepperRoutes={stepperRoutes}
            showTradeErrorMessage={false}
            staticAssetsConfig={config.staticImages}
            stepLabelVisible={true}
            isStepperClickable={true}
            cdlPageProgressStepperClicked={cdlTradeInProgressStepperClicked}
            urlPath={urlPath}
        >
            <div className="loan-confirmation-container">
                <div className="loan-confirmation-header">
                    <p className="title">Looks like we located your open auto loan.</p>
                </div>

                <div className="loan-details-table">
                    <div className="table-header">
                        <p className="vehicle-name">{vehicleName}</p>
                        <p className="vehicle-trim">{trim}</p>
                    </div>
                    <div className="table-body">
                        <div className="loan-info">
                            <div className="loan-info-details">
                                <p className="title">VIN:</p>
                                <p className="value">{vin}</p>
                            </div>
                            <div className="loan-info-details">
                                <p className="title">Lender:</p>
                                <p className="value">{lenderName}</p>
                            </div>
                            <div className="loan-info-details">
                                <p className="title">Loan Balance:</p>
                                <p className="value">{loanBalance}</p>
                            </div>
                        </div>

                        <div className="continue-button-container">
                            <button data-testid="confirm-and-continue-button" className="btn btn-primary" onClick={next}>
                                Confirm & Continue
                            </button>
                        </div>
                    </div>
                </div>

                <p className="estimate-loan-balance-link">
                    You can also{' '}
                    <a data-testid="estimate-loan-balance-link" className="primary-link" onClick={onEstimateBalanceClick}>
                        estimate your loan balance.{' '}
                    </a>
                    We'll confirm the exact amount before finalizing your purchase.
                </p>
            </div>
        </TradePage>
    );
};

export default LoanConfirmationUI;
